import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
      light: "#4791db",
      dark: "#115293",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#BCE910",
      light: "#D6FF47",
      dark: "#9BC107",
    },

    secondaryShades: {
      100: "#0D0D0A", // RGB: 13-13-10
      200: "#1D2435", // RGB: 29-36-53
      300: "#2D3A65", // RGB: 45-58-101
      400: "#2C3478", // RGB: 44-52-120
      500: "#3F4BA7", // RGB: 63-75-167
      600: "#5049B9", // RGB: 80-73-185
      700: "#6048CC", // RGB: 96-72-204
      800: "#8048CD", // RGB: 128-72-205
      900: "#B048CD", // RGB: 176-72-205
    },
    // Secondary shades from bottom row
    secondaryAlt: {
      100: "#3499F3", // RGB: 52-153-243
      200: "#5F4CF5", // RGB: 95-76-245
      300: "#A58FF7", // RGB: 165-143-247
      400: "#8FCFF7", // RGB: 143-207-247
      500: "#CD6FF7", // RGB: 205-111-247
      600: "#E8D7F7", // RGB: 232-215-247
    },
    // Typography shades
    typography: {
      100: "#0D0D0A", // RGB: 13-13-10
      200: "#525459", // RGB: 82-84-89
      300: "#929295", // RGB: 146-146-149
      400: "#AEAEAE", // RGB: 174-174-174
    },
    // Tertiary shades - Orange
    orange: {
      100: "#FC665C", // RGB: 252-102-92
      200: "#FC7D5E", // RGB: 252-125-94
      300: "#FC885F", // RGB: 252-136-95
      400: "#FC9A63", // RGB: 252-154-99
    },
    // Tertiary shades - Yellow
    yellow: {
      100: "#FFC700", // RGB: 255-199-0
      200: "#FF7D0F", // RGB: 255-125-15
      300: "#FFD633", // RGB: 255-214-51
      400: "#FFEA19", // RGB: 255-234-25
    },
    // Tertiary shades - Green
    green: {
      100: "#C6EA19", // RGB: 198-234-25
      200: "#CBEFC7", // RGB: 203-239-199
      300: "#DCE754", // RGB: 220-231-84
      400: "#D7E7B8", // RGB: 215-231-184
    },
    background: {
      default: "#F8F9FA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0D0D0A", // Using typography.100 for main text
      secondary: "#525459", // Using typography.200 for secondary text
    },
    divider: "#F3F4F6",
    disabled: "#EFEBEF",
    grey: {
      50: "#F8F9FA",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
  // Add custom colors for sidebar
  sidebar: {
    primary: "#FFFFFF",
    secondary: "#FFFFFF",
    text: {
      primary: "#1976d2",
      secondary: "#1976d2",
    },
    hover: "rgba(25, 118, 210, 0.08)",
    active: "rgba(25, 118, 210, 0.12)",
    divider: "#F3F4F6",
    iconSize: "12px",
    tableIconSize: "12px",
    gray07: "#6b7280",
    fontSize: "13px",
  },
});

export default lightTheme;
